import { capitalize } from '../../utils/string'

export default class Descriptor {
  /**
   * Conventions
   * - name is in lower case
   * - local data is in store with specific keys
   * - action names are as follows
   * @param {string} name - Resource name
   */
  constructor (name) {
    this.name = name
    this.resourceName = capitalize(name)
    this.provider = {
      list: state => state[name][`${name}List`],
      one: state => state[name][name]
    }
    this.fetch = {
      list: ($store, params) => {
        $store.dispatch(`load${this.resourceName}List`, params)
      },
      one: ($store, id) => {
        $store.dispatch(`load${this.resourceName}`, id)
      }
    }
    this.update = ($store, params) => {
      return $store.dispatch(`update${this.resourceName}`, params)
    }
    this.add = ($store, params) => {
      return $store.dispatch(`add${this.resourceName}`, params)
    }
    this.delete = ($store, params) => {
      return $store.dispatch(`delete${this.resourceName}`, params)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/helper/resource/Descriptor.js